// extracted by mini-css-extract-plugin
export default {"Form":"Form_Form__9U6gC","Container":"Form_Container__K9g7K"};